import React from "react";
import { connect } from "react-redux";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";

function Address({ language, themeColor, branch, baseCountry }) {
  const renderAddress = () => {
    let address = "";
    const translations = {
      Block: baseCountry == "Bahrain" ? "مجمع" : "قطعة",
      Zone: "منطقة",
      Street: "شارع",
      Building: "مبنى",
      Avenue: "جادة",
      Floor: "طابق",
      Apartment: "شقة",
    };
    const re = (field) => (language === "arabic" ? translations[field] : field);
    if (branch.avenue)
      address = address.concat(`${re("Avenue")}: ${branch.avenue}, `);
    if (branch.block && baseCountry !== "Qatar")
      address = address.concat(`${re("Block")}: ${branch.block}, `);
    if (branch.zone && baseCountry === "Qatar")
      address = address.concat(`${re("Zone")}: ${branch.zone}, `);
    if (branch.street)
      address = address.concat(`${re("Street")}: ${branch.street}, `);
    if (branch.building)
      address = address.concat(`${re("Building")}: ${branch.building}, `);
    if (branch.floor)
      address = address.concat(`${re("Floor")}: ${branch.floor}, `);
    if (branch.apartment)
      address = address.concat(`${re("Apartment")}: ${branch.apartment}, `);
    if (address.endsWith(", ")) address = address.slice(0, -2);
    return address;
  };
  if (!renderAddress() && !branch.additional) return <></>;
  return (
    <div style={{ marginTop: 35 }}>
      <p
        className="box-title"
        style={{ textAlign: language === "arabic" ? "right" : "left" }}
      >
        {language == "arabic" ? "العنوان" : "Address"}
      </p>
      <div
        style={{
          minHeight: 70,
          direction: language === "english" ? "ltr" : "rtl",
          backgroundColor: "white",
          display: "grid",
          gridTemplateColumns: "40px auto",
          padding: "20px 20px",
          textAlign: language === "arabic" ? "right" : "left",
        }}
        className="w-100 bordered"
      >
        <div>
          <LocationOnOutlinedIcon style={{ fontSize: 30, color: themeColor }} />
        </div>
        <div
          style={{ [`padding${language === "arabic" ? "Right" : "Left"}`]: 10 }}
        >
          <p className="bold mb-1">
            {language === "arabic" ? branch.ar_area : branch.area}
          </p>
          <p>{renderAddress()}</p>
          {!!branch.additional && (
            <p>
              {language === "arabic" ? "معلومات" : "Info"}: {branch.additional}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark || "#0099cc",
    baseCountry: state.store.store.base_country,
  };
};
export default connect(mapStateToProps)(Address);
